export default __webpack_public_path__ + "static/media/38.9c9b7fcb.jpg";